import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { ReportingRoutes } from 'src/components/AppRoutes/ReportingRoutes';
import { buildCMUIPath, CMUIPage } from 'src/constants/urls';
import { useReportingFeatureAccess } from 'src/components/enterprise/features/Reporting/Routes/useReportingFeatureAccess/useReportingFeatureAccess';

export const ReportingAccessGate = (): JSX.Element => {
  const { corpid: corpId } = useParams<{ corpid: string }>();
  const { canAccessReporting, isLoading } = useReportingFeatureAccess();

  if (isLoading) {
    return null;
  }

  if (!canAccessReporting) {
    return <Redirect to={buildCMUIPath(CMUIPage.HOME, { corpId })} />;
  }

  return <ReportingRoutes />;
};
